import { inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHandlerFn, HttpEventType } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { AuthenticationService } from '@services/authentication.service';
import { SnackbarService } from '@services/snackbar.service';

export function errorInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn) {
  const auth = inject(AuthenticationService);
  const sb = inject(SnackbarService);
  return next(request)
  .pipe(
    catchError(err => {
      const error = err.reason || err.error?.reason || err.error?.message || err.statusText;
      if (err.status == 401) {
        auth.logout();
      }
      if ([400, 403, 500].includes(err.status)) {
        sb.open(error);
      }
      return throwError(() => error);
    })
  );
}